import React from 'react'
import {useState} from 'react'
import { useEffect } from 'react';



import Nav from './Nav'
import About from './About'
import Projects from './Projects'
import Title from './Title'

// import TerminalMusicEditor from './TerminalMusicEditor';
// import GaryBuseyLookALikes from './GaryBuseyLookALikes';
// import GetLucky3000 from './GetLucky3000'
// import Background from './Backgtound';






const Main = () => {

    const [change, setChange] = useState('false');
    const [change2, setChange2] = useState('false');


    useEffect(() => {

    

        const superChange = () => {
            if (change==='false') {
    
            } else {
                setChange2('true')
            }
        }
        superChange()

        
    })


    return (

            
            





                        <div style={{position: 'relative', overflow: 'hidden'}}>
                            


                            <Nav myfunction={setChange} id='nav'/>

                            <div id='title'>
                                <Title />
                            </div>

                            <div id='about'>
                                <About />
                            </div>

                            <div id='projects'>
                                <Projects change={change2}/>
                            </div>
                            
                        </div>



            
            

    )
}



export default Main